// import { PUZZLES_OBJECT } from "../../utils/constants";
import React from "react";
import "./PuzzlePopup.css";

function PuzzlePopup({ puzzle, popupStateOpen }) {
  const handleClosePopup = (e) => {
    console.log(e.target);
  };

  const handleCheckPuzzle = () => {
    console.log(puzzle.answer);
    console.log(inputValue);
    if (puzzle.answer.toLowerCase() === inputValue.toLowerCase()) {
      console.log("You WIN!");
    } else {
      console.log("You LOSE!");
    }
  };

  const [inputValue, setInputValue] = React.useState();
  return (
    <>
      <div
        className={
          popupStateOpen ? `puzzle__popup puzzle__popup_open` : `puzzle__popup`
        }
        onClick={(e) => handleClosePopup(e)}
      >
        <div className='puzzle__popup_container'>
          <img src={process.env.PUBLIC_URL + puzzle.path} alt={puzzle.alt} />
          <input
            placeholder='Enter your answer here'
            onChange={(e) => setInputValue(e.target.value)}
          />
          <button onClick={handleCheckPuzzle}>Check</button>
        </div>
      </div>
    </>
  );
}

export default PuzzlePopup;
